import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Products.css";
import contact from "../Images/Group-of-customer-service-representatives.jpg";
import "./Products.css";
import image1 from "../Images/Mr.Olive/jalapeno/فلفل شيري سليم.jpg";
import image2 from "../Images/Mr.Olive/jalapeno/فلفل شيري مخلي.jpg";
import image3 from "../Images/Mr.Olive/jalapeno/فلفل هاليبينو أحمر سليم.jpg";
import image4 from "../Images/Mr.Olive/jalapeno/فلفل هاليبينو أحمر شرائح.jpg";
import image5 from "../Images/Mr.Olive/jalapeno/فلفل لمباردي.jpg";
import image6 from "../Images/Mr.Olive/jalapeno/فلفل مكسيكي.jpg";
import image7 from "../Images/Mr.Olive/jalapeno/فلفل هاليبينو أخضر سليم 1.jpg";
import image8 from "../Images/Mr.Olive/jalapeno/هاليبينو اخضر.jpg";
import image9 from "../Images/Mr.Olive/jalapeno/هريسة.jpg";
import image10 from "../Images/Mr.Olive/mix/فلفل بنانا شرائح مخلي.jpg";
import image24 from "../Images/Mr.Olive/packages/_KH13102-Recovered.jpg";
import image25 from "../Images/Mr.Olive/jalapeno/edited 3.jpg";
import image26 from "../Images/Mr.Olive/jalapeno/edited 4.jpg";

export default function ProductCat3Russ() {
  const [currID, setCurrID] = useState("");
  const [loading, setLoading] = useState(false);
  const [productName, setProductName] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  async function sendQuote(e) {
    e.preventDefault();
    setLoading(true);
    axios
      .post(
        `https://mrolive-back-end-2c3o.onrender.com/api/v1/quote`,
        {
          name: name,
          email: email,
          productName: productName,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        toast.success(response?.data?.msg);
        setName("");
        setEmail("");
        document.getElementById("name").value = "";
        document.getElementById("email").value = "";
      })
      .catch((e) => {
        toast.error(e?.data?.msg);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  let imgList = Array.from(document.getElementsByClassName("imgItem"));
  let lightContainer = document.querySelector(".lightContainer");
  let lightBox = document.querySelector(".lightBox");
  let currentIndex = 0;
  let tmp = [
    {
      id: "1",
      text: ``,
      table: (
        <table class="  table-bordered ">
          <thead>
            <tr>
              <th>описание товара</th>
              <th>Длина</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Целые красные перцы черри</th>
              <td> 25-50 MM </td>
            </tr>
          </tbody>
        </table>
      ),
    },
    {
      id: "2",
      text: ``,
      table: (
        <table class="  table-bordered ">
          <thead>
            <tr>
              <th>описание товара</th>
              <th>Длина</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th> Красный перец черри без косточек</th>
              <td> 25-50 MM </td>
            </tr>
          </tbody>
        </table>
      ),
    },
    {
      id: "3",
      text: ``,
      table: (
        <table class="  table-bordered ">
          <thead>
            <tr>
              <th>описание товара</th>
              <th>Длина</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th> 3. Целый красный перец халапеньо</th>
              <td> 4-8 CM </td>
            </tr>
          </tbody>
        </table>
      ),
    },
    {
      id: "4",
      text: ``,
      table: (
        <table class="  table-bordered ">
          <thead>
            <tr>
              <th>описание товара</th>
              <th>Толщина ломтиков</th>
              <th>Диаметр ломтиков</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Нарезанный красный перец халапеньо</th>
              <td>1 cm </td>
              <td>1.5 cm : 3.5 cm </td>
            </tr>
          </tbody>
        </table>
      ),
    },
    { id: "5", text: ``, table: "" },
    {
      id: "6",
      text: ``,
      table: (
        <table class="  table-bordered ">
          <thead>
            <tr>
              <th>описание товара</th>
              <th colSpan="2">Длина</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th rowSpan="2">5. Мексиканский перец</th>
              <td> Средняя </td>
              <td> 3-6 CM </td>
            </tr>
            <tr>
              <td> Большие </td>
              <td> 6-10 CM </td>
            </tr>
          </tbody>
        </table>
      ),
    },
    {
      id: "7",
      text: ` `,
      table: (
        <table class="  table-bordered ">
          <thead>
            <tr>
              <th>описание товара</th>
              <th>Длина</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>1. Целый зеленый перец халапеньо</th>
              <td> 4-8 CM </td>
            </tr>
          </tbody>
        </table>
      ),
    },
    {
      id: "8",
      text: ``,
      table: (
        <table class="  table-bordered ">
          <thead>
            <tr>
              <th>описание товара</th>
              <th>Толщина ломтиков</th>
              <th>Диаметр ломтиков</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th> 2. нарезанный зеленый перец халапеньо</th>
              <td> 0.5 cm </td>
              <td> 1.5 cm : 3 cm </td>
            </tr>
          </tbody>
        </table>
      ),
    },
    { id: "9", text: `` },
    {
      id: "10",
      text: ``,
      table: (
        <table class="  table-bordered ">
          <thead>
            <tr>
              <th>описание товара</th>
              <th>Толщина ломтиков </th>
              <th>Диаметр ломтиков</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>Нарезанный банановый перец</th>
              <td> 6 MM </td>
              <td>3 cm : 6 cm </td>
            </tr>
          </tbody>
        </table>
      ),
    },
    { id: "11", text: `` },
  ];
  function showImage(x) {
    document
      .querySelector(".lightContainer2")
      .classList.replace("d-none", "d-flex");
    // console.log("ayhagaaasa")
    document.querySelector(".very").style.backgroundImage = `url(${x.src})`;
    document.querySelector(".productName").innerHTML = x.name;

    currentIndex = x.id;
    setCurrID(currentIndex);

    // console.log(currentIndex)
  }

  function closeSlide() {
    document
      .querySelector(".lightContainer2")
      .classList.replace("d-flex", "d-none");
  }
  function showForm() {
    document
      .querySelector(".showForm")
      .classList.replace("d-none", "d-inline-block");
  }
  return (
    <>
      <ToastContainer />

      <div className="products"></div>
      <div className="container p-4">
        <div className="row p-3">
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="1"
                src={image1}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("Целые красные перцы черри");
                }}
                alt="image not found"
                className="photo"
                name="Целые красные перцы черри"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              Целые красные перцы черри
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="2"
                src={image2}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("Красный перец черри без косточек");
                }}
                alt="image not found"
                className="photo"
                name="Красный перец черри без косточек"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              Красный перец черри без косточек
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="3"
                src={image3}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("Целый красный перец халапеньо");
                }}
                alt="image not found"
                className="photo"
                name="Целый красный перец халапеньо"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              Целый красный перец халапеньо
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="4"
                src={image4}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("Нарезанный красный перец халапеньо");
                }}
                alt="image not found"
                className="photo"
                name="Нарезанный красный перец халапеньо"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              Нарезанный красный перец халапеньо
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="5"
                src={image5}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("Маринованный перец лампарди");
                }}
                alt="image not found"
                className="photo"
                name="Маринованный перец лампарди"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              Маринованный перец лампарди
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="6"
                src={image6}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("Мексиканский перец");
                }}
                alt="image not found"
                className="photo"
                name="Мексиканский перец"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              Мексиканский перец
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="7"
                src={image7}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("Целый зеленый перец халапеньо");
                }}
                alt="image not found"
                className="photo"
                name="Целый зеленый перец халапеньо"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              Целый зеленый перец халапеньо
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="8"
                src={image8}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("нарезанный зеленый перец халапеньо");
                }}
                alt="image not found"
                className="photo"
                name="нарезанный зеленый перец халапеньо"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              нарезанный зеленый перец халапеньо
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="9"
                src={image9}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("протертый красный перец");
                }}
                alt="image not found"
                className="photo"
                name="протертый красный перец"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              протертый красный перец
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="10"
                src={image10}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("Нарезанный банановый перец");
                }}
                alt="image not found"
                className="photo"
                name="Нарезанный банановый перец"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              Нарезанный банановый перец
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className=" imgItem">
              <img
                id="11"
                src={image24}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("половина перца");
                }}
                alt="image not found"
                className="photo"
                name="половина перца"
              />{" "}
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              половина перца
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className=" imgItem">
              <img
                id="25"
                src={image25}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("Красный перец");
                }}
                alt="image not found"
                className="photo"
                name="Красный перец"
              />{" "}
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}></p>
          </div>{" "}
          <div className="col-md-4 photoContainer2">
            <div className=" imgItem">
              <img
                id="26"
                src={image26}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("половина красного перца");
                }}
                alt="image not found"
                className="photo"
                name="половина красного перца"
              />{" "}
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}></p>
          </div>
        </div>
      </div>
      <div className="lightContainer2 d-none  align-items-center">
        <div className="lightBox2  ">
          <div className="container">
            <div className="row d-flex justify-content-center ">
              <div className="ayhaga" style={{ marginTop: "30px" }}>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <img className=" very" alt="" style={{ padding: "0" }} />
                </div>
                <h4
                  className="productName"
                  style={{
                    color: "#4e732c",
                    display: "flex",
                    justifyContent: "center",
                  }}
                ></h4>
                {tmp.map((each) => {
                  if (each.id === currID) {
                    return (
                      <div>
                        <p style={{ color: "white" }}>
                          {" "}
                          Египет стал одной из ведущих стран по производству и
                          изготовлению перца всех видов. Наша компания внедрила
                          современные методы в сельском хозяйстве, производстве
                          и упаковке, а также мировые конкурентоспособные цены.
                        </p>
                        <div>{each.table}</div>
                      </div>
                    );
                  }
                })}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "10px",
                  }}
                >
                  <button
                    className="btn get bgDark"
                    style={{ marginBottom: "5px" }}
                    onClick={showForm}
                  >
                    Получить предложение
                  </button>
                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <form onSubmit={sendQuote}>
                    <div className="showForm d-none ">
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        placeholder="Введите ваше имя"
                        style={{ marginBottom: "5px" }}
                        onChange={(e) => {
                          setName(e.target.value);
                        }}
                      />
                      <input
                        type="email"
                        className="form-control"
                        // id="exampleFormControlInput2"
                        id="email"
                        placeholder="Введите адрес электронной почты"
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                      />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          margin: "10px",
                        }}
                      >
                        <button
                          className="btn get"
                          style={{ marginTop: "5px" }}
                          type="submit"
                        >
                          {loading ? (
                            <i className="fa-solid fa-spinner fa-spin"></i>
                          ) : (
                            "Отправить"
                          )}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          {/* <img src={image1} alt="image not found" className='lightBox'/> */}

          <i
            style={{
              color: "black",
              backgroundColor: "white",
              padding: "10px",
              borderRadius: "10px",
            }}
            id="close"
            className="fa-solid fa-xmark"
            onClick={closeSlide}
          ></i>
        </div>
      </div>
      <div
        className="row"
        style={{
          backgroundColor: "#4e732c",
          color: "white",
          margin: "0",
          display: "flex",
          justifyContent: "end",
        }}
      >
        <div className="col-md-7 col-sm-8" style={{ marginTop: "25px" }}>
          <div className="container">
            <div className="row ">
              <div
                className="col-md-12"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <div className="contactContect">
                  <h6> свяжитесь с нами</h6>

                  <p>когда у вас есть вопрос, мы здесь, чтобы помочь</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-1 col-sm-4"
          style={{ backgroundColor: "#4e732c" }}
        ></div>
        <div className="col-md-4 col-sm-12 " style={{ padding: "0" }}>
          <img src={contact} alt="" className="contactMeFooter" />
        </div>
      </div>
    </>
  );
}
